import { compose, hoistStatics } from 'recompose';
import MetaDataFields from './MetaDataFields';

const enhance = compose();

export default hoistStatics(enhance)(MetaDataFields);



// WEBPACK FOOTER //
// ./src/components/cms/metaDataFields/index.js